import _ from 'lodash';

import { GeneratePayStringNodesParams, PayStringElement } from './model';
import { MONTHS } from './constants';

export const getNodeColorClasses = (letter?: string): string => {
  switch (letter) {
    case 'L':
      return 'bg-[#FCCF74] text-black';
    case 'D':
      return 'bg-[#E95C7B] text-black';
    case 'C':
      return 'bg-[#5DC389] text-black';
    case '':
    case null:
    case undefined:
      return 'bg-white text-white opacity-0'; // Invisible placeholder node
    default:
      return 'bg-black text-white';
  }
};

export const generatePayStringNodes = ({
  paystringData,
  showLastNMonth,
}: GeneratePayStringNodesParams): PayStringElement[] => {
  // Filter data to show only last N months if specified
  let filteredData = paystringData;
  if (showLastNMonth && showLastNMonth > 0) {
    const sortedData = _.orderBy(paystringData, ['month'], ['desc']);
    filteredData = _.take(sortedData, showLastNMonth);
  }

  // Create a map of month number to data using lodash
  const monthDataMap = _.keyBy(filteredData, 'month');

  // Render all 12 months (or only filtered months if showLastNMonth is set)
  const elements: PayStringElement[] = [];
  let lastHadData = false;

  // Determine which months to render
  const monthsToRender =
    showLastNMonth && showLastNMonth > 0
      ? _.map(filteredData, 'month').sort((a, b) => a - b)
      : _.range(1, 13);

  monthsToRender.forEach((monthNumber) => {
    const monthName = MONTHS[monthNumber - 1];
    const monthData = monthDataMap[monthNumber];
    const hasData = !!monthData && !!monthData.letter;

    // Add dash/spacing before the node (except for the first one)
    if (elements.length > 0) {
      if (hasData && lastHadData) {
        // Both nodes have data - show dash
        elements.push({
          type: 'dash',
          key: `dash-${monthNumber}`,
        });
      } else {
        // At least one node has no data - show empty space (same width as dash)
        elements.push({
          type: 'space',
          key: `space-${monthNumber}`,
        });
      }
    }

    if (hasData) {
      // Show data node with the actual letter
      elements.push({
        type: 'node',
        key: `node-${monthNumber}`,
        letter: monthData?.letter?.toUpperCase(),
        monthName,
      });
    } else {
      // No data for this month - show empty white node
      elements.push({
        type: 'node',
        key: `missing-${monthNumber}`,
        letter: '',
        monthName,
      });
    }

    lastHadData = hasData;
  });

  return elements;
};
